import { Button } from "@quest/ui/components/button";
import { useAppDispatch } from "@quest/hooks";
import { clearViewAsPreview } from "@quest/slice";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Eye } from "lucide-react";
import { useViewAsPreview } from "@/libs/hooks/use-view-as-preview";

function ViewAsStudentBanner() {
  const { isPreviewMode, displayName, returnTo, studentId } =
    useViewAsPreview();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation("Students");

  if (!isPreviewMode) return null;

  const handleExit = async () => {
    const target = studentId
      ? `/admin/students/${studentId}`
      : returnTo || "/admin";
    // Navigate first and commit it synchronously. If the preview is cleared
    // while a student route is still mounted, AuthGuard sees a staff user on
    // a student-only route and redirects to the home page, overriding target.
    await navigate(target, { replace: true, flushSync: true });
    dispatch(clearViewAsPreview());
  };

  return (
    <div className="sticky top-0 z-50 mb-4 flex items-center justify-between gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-amber-950 shadow-sm">
      <div className="flex items-center gap-2 text-sm font-medium">
        <Eye className="h-4 w-4 shrink-0" />
        <span>
          {t("viewingAsStudent", { name: displayName || t("student") })}
        </span>
        <span className="text-amber-800/80 font-normal">
          — {t("readOnlyPreview")}
        </span>
      </div>
      <Button size="sm" variant="outline" onClick={handleExit}>
        {t("exitViewAsStudent")}
      </Button>
    </div>
  );
}

export default ViewAsStudentBanner;
